import React from 'react';
import { Button, Box } from '@mui/material';

interface CaseButtonProps {
  enabled: boolean;
  isProcessing: boolean;
  onClick: () => void;
  variant?: 'mobile' | 'desktop';
  size?: 'small' | 'medium';
}

const CaseButton: React.FC<CaseButtonProps> = ({
  enabled,
  isProcessing,
  onClick,
  variant = 'desktop',
  size = 'small'
}) => {
  const iconSrc = isProcessing 
    ? new URL('../assets/gekko_eye_spinning.gif', import.meta.url).href
    : new URL('../assets/gekko_eye.png', import.meta.url).href;

  const buttonText = isProcessing ? 'Processing' : 'Case';

  return (
    <Button
      variant={variant === 'desktop' ? 'contained' : 'outlined'}
      size={size}
      onClick={onClick}
      disabled={!enabled}
      startIcon={
        <Box
          component="img"
          src={iconSrc}
          alt="Gekko Case"
          sx={{
            width: size === 'small' ? 16 : 20,
            height: size === 'small' ? 16 : 20,
            opacity: enabled ? 1 : 0.5,
          }}
        />
      }
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        minWidth: 'auto',
        opacity: enabled ? 1 : 0.5,
        '&:disabled': {
          color: 'text.disabled',
          backgroundColor: variant === 'desktop' ? 'action.disabledBackground' : 'transparent',
          borderColor: variant === 'desktop' ? 'transparent' : 'action.disabled',
        },
      }}
    >
      {buttonText}
    </Button>
  );
};

export default CaseButton;